module.exports = {
	"root": "findify-layouts--content",
	"content": "findify-layouts--content__content"
};